import React, { useEffect, useState } from "react"
import { apiFetch } from "../utils/apiFetch"

export default function DoctorPermissionsAdmin() {
  const API_BASE =
  (typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname)
    ? ["http://localhost", "3000/api"].join(":")
    : "/api")
  const [userId] = useState("e922ef71-7119-4f8c-8b73-3c8c42629ebd")

  const [clinics, setClinics] = useState([])
  const [clinicId, setClinicId] = useState("")
  const [doctors, setDoctors] = useState([])
  const [doctorId, setDoctorId] = useState("")
  const [doctor, setDoctor] = useState(null)
  const [treatments, setTreatments] = useState([])
  const [selectedTreatmentIds, setSelectedTreatmentIds] = useState([])
  const [saving, setSaving] = useState(false)

  const specialties = [
    { value: "", label: "Sin especialidad especÃ­fica" },
    { value: "GENERAL", label: "General" },
    { value: "ORTODONCIA", label: "Ortodoncia" },
    { value: "ENDODONCIA", label: "Endodoncia" },
    { value: "CIRUGIA", label: "CirugÃ­a" },
    { value: "IMPLANTOLOGIA", label: "ImplantologÃ­a" },
    { value: "PROSTODONCIA", label: "Prostodoncia" },
    { value: "PERIODONCIA", label: "Periodoncia" },
    { value: "PEDIATRIA", label: "OdontopediatrÃ­a" }
  ]

  const cardStyle = {
    borderRadius: 18,
    padding: 18,
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    boxShadow: "0 10px 25px rgba(15, 23, 42, 0.06)"
  }

  const loadClinics = async () => {
    try {
      const res = await apiFetch(`${API_BASE}/multi-clinic/user-clinics?userId=${userId}`)
      const data = await res.json().catch(() => [])
      const rows = Array.isArray(data) ? data : []
      setClinics(rows)

      if (rows.length > 0 && !clinicId) {
        setClinicId(rows[0].clinicId)
      }
    } catch {
      setClinics([])
    }
  }

  const loadDoctors = async (cId = clinicId) => {
    try {
      if (!cId) return
      const res = await apiFetch(`${API_BASE}/multi-clinic/clinic-doctors?clinicId=${cId}`)
      const data = await res.json().catch(() => [])
      const rows = Array.isArray(data) ? data : []
      setDoctors(rows)

      if (rows.length > 0 && !doctorId) {
        setDoctorId(rows[0].id)
        setDoctor(rows[0])
      }
    } catch {
      setDoctors([])
    }
  }

  const loadTreatments = async (cId = clinicId) => {
    try {
      if (!cId) return
      const res = await apiFetch(`${API_BASE}/treatments?clinicId=${cId}`)
      const data = await res.json().catch(() => [])
      setTreatments(Array.isArray(data) ? data : [])
    } catch {
      setTreatments([])
    }
  }

  const loadPermissions = async (dId = doctorId) => {
    try {
      if (!dId) return
      const res = await apiFetch(`${API_BASE}/doctor-treatments/permissions?doctorId=${dId}`)
      const data = await res.json().catch(() => [])
      setSelectedTreatmentIds(Array.isArray(data) ? data.map((x) => x.treatmentId) : [])
    } catch {
      setSelectedTreatmentIds([])
    }
  }

  useEffect(() => {
    loadClinics()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!clinicId) return
    loadDoctors(clinicId)
    loadTreatments(clinicId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicId])

  useEffect(() => {
    if (!doctorId) return
    const found = doctors.find((d) => d.id === doctorId)
    setDoctor(found || null)
    loadPermissions(doctorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doctorId, doctors])

  const toggleTreatment = (treatmentId) => {
    setSelectedTreatmentIds((prev) =>
      prev.includes(treatmentId)
        ? prev.filter((id) => id !== treatmentId)
        : [...prev, treatmentId]
    )
  }

  const handleSave = async () => {
    try {
      setSaving(true)

      const specialtyRes = await apiFetch(`${API_BASE}/multi-clinic/doctor-specialty`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          doctorId,
          specialty: doctor?.specialty || null
        })
      })

      if (!specialtyRes.ok) {
        alert("No se pudo guardar la especialidad del doctor")
        return
      }

      const permissionsRes = await apiFetch(`${API_BASE}/doctor-treatments/permissions/replace`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          doctorId,
          clinicId,
          treatmentIds: selectedTreatmentIds
        })
      })

      if (!permissionsRes.ok) {
        alert("No se pudieron guardar los tratamientos permitidos")
        return
      }

      alert("ConfiguraciÃ³n guardada")
    } catch {
      alert("No se pudo guardar la configuraciÃ³n")
    } finally {
      setSaving(false)
    }
  }

  return (
    <div style={{ padding: 20, background: "#f8fafc", minHeight: "100vh" }}>
      <div style={{ ...cardStyle, marginBottom: 20 }}>
        <div style={{ fontSize: 28, fontWeight: 800, marginBottom: 6 }}>
          ConfiguraciÃ³n clÃ­nica de doctores
        </div>
        <div style={{ color: "#475569", fontSize: 14 }}>
          Define la especialidad principal y los tratamientos que realiza cada doctor.
          En clÃ­nicas con un solo doctor, el sistema serÃ¡ flexible para no bloquear operaciÃ³n.
        </div>
      </div>

      <div style={{ ...cardStyle, marginBottom: 20 }}>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <select
            value={clinicId}
            onChange={(e) => {
              setClinicId(e.target.value)
              setDoctorId("")
              setDoctor(null)
            }}
            style={{ padding: 10, borderRadius: 10, border: "1px solid #cbd5e1" }}
          >
            {clinics.map((c) => (
              <option key={c.id} value={c.clinicId}>
                {c.clinic?.name || c.clinicName || c.name || "ClÃ­nica"}
              </option>
            ))}
          </select>

          <select
            value={doctorId}
            onChange={(e) => setDoctorId(e.target.value)}
            style={{ padding: 10, borderRadius: 10, border: "1px solid #cbd5e1" }}
          >
            {doctors.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {doctor && (
        <>
          <div style={{ ...cardStyle, marginBottom: 20 }}>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>
              Especialidad principal
            </div>

            <select
              value={doctor.specialty || ""}
              onChange={(e) =>
                setDoctor((prev) => ({
                  ...prev,
                  specialty: e.target.value || null
                }))
              }
              style={{ padding: 10, borderRadius: 10, border: "1px solid #cbd5e1", minWidth: 280 }}
            >
              {specialties.map((s) => (
                <option key={s.value} value={s.value}>
                  {s.label}
                </option>
              ))}
            </select>
          </div>

          <div style={{ ...cardStyle, marginBottom: 20 }}>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>
              Tratamientos que tambiÃ©n realiza
            </div>

            <div style={{ display: "grid", gap: 10 }}>
              {treatments.map((t) => (
                <label
                  key={t.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: 10,
                    borderRadius: 10,
                    background: "#f8fafc",
                    border: "1px solid #e5e7eb"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedTreatmentIds.includes(t.id)}
                    onChange={() => toggleTreatment(t.id)}
                  />
                  <span style={{ fontWeight: 600 }}>{t.name}</span>
                </label>
              ))}
            </div>
          </div>

          <div style={cardStyle}>
            <button
              onClick={handleSave}
              disabled={saving}
              style={{
                padding: "10px 16px",
                borderRadius: 10,
                border: "1px solid #cbd5e1",
                background: "#ecfeff",
                cursor: "pointer"
              }}
            >
              {saving ? "Guardando..." : "Guardar configuraciÃ³n"}
            </button>
          </div>
        </>
      )}
    </div>
  )
}
